import type { IExtendedSkipMarker } from '@dicetechnology/dice-unity/lib/types/content';
import { clip } from '@dicetechnology/doris-core';

import type { ExtendedSkipMarker } from '../types';

export function mapExtendedSkipMarker(marker: IExtendedSkipMarker): ExtendedSkipMarker {
    const { startTimeMs, stopTimeMs, title, titleLocalisations } = marker;
    return {
        title,
        titleLocalisations,
        start: clip(startTimeMs / 1000),
        end: clip(stopTimeMs / 1000)
    };
}
